import { OrdersActions } from "../../types";

export function update(
  orderId: number,
  shippedItemId: number,
  data: Object,
): any {
  return {
    types: OrdersActions.ScheduleUpdate,
    method: "put",
    url: `api/v1/crm/orders/${orderId}/schedule_items/${shippedItemId}?schedule_order=true`,
    data,
  };
}

export function destroy(orderId: number, shippedItemId: number): any {
  return {
    types: OrdersActions.ScheduleDestroy,
    method: "delete",
    url: `api/v1/crm/orders/${orderId}/schedule_items/${shippedItemId}?schedule_order=true`,
  };
}

export function destroyAll(orderId: number, data: any): any {
  return {
    types: OrdersActions.ScheduleDestroyAll,
    method: "delete",
    url: `api/v1/crm/orders/${orderId}/schedule_items?schedule_order=true`,
    data,
  };
}
